'use es6';

import { connect } from 'react-redux';
import { isCaptchaEnabled, isCaptchaConfigurable } from 'FormsUI/selectors/FormDefinition';
import { updateValueOnFormDefinition } from 'FormsUI/actions/FormDefinition';
import Captcha from './Captcha';
const mapStateToProps = state => ({
  captchaEnabled: isCaptchaEnabled(state),
  captchaConfigurable: isCaptchaConfigurable(state)
});
const actionCreators = {
  updateValueOnFormDefinition
};
export default connect(mapStateToProps, actionCreators)(Captcha);